var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAzureAiFoundry = function SvgAzureAiFoundry(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M15.772.91c.659 0 1.243.51 1.453 1.228.21.72 1.437 5.167 1.437 5.167v8.836h-4.448l.09-15.23h1.468Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M22.302 7.814a.553.553 0 0 0-.554-.554h-2.621a3.343 3.343 0 0 0-3.34 3.34v5.541h3.175a3.343 3.343 0 0 0 3.34-3.34V7.814Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M15.772.91a.908.908 0 0 0-.914.914l-.09 16.818a4.449 4.449 0 0 1-4.447 4.448H2.248a.552.552 0 0 1-.524-.734L8.194 3.89A4.453 4.453 0 0 1 12.387.91h3.4-.015Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 17.629,
    x2: 13.885,
    y1: 16.471,
    y2: 1.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#712575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9A2884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#BF2C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#DA2E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB30A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F131A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EC30A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DF2F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C92D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AA2A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#83267C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#712575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.052,
    x2: 19.052,
    y1: 1.225,
    y2: 22.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA7ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B17BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8778DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6276E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4574E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2E72E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1D71EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#1471EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1171ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.779,
    x2: 3.761,
    y1: 1.704,
    y2: 24.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA7ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B77BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#9079DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6E77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5175E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3973E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2772E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1A71EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1371EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1171ED"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAzureAiFoundry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "azure-ai-foundry.e498fad2ca187fabf62ecbf677b3b561.svg";